import { render } from "./CostReportDetails.vue?vue&type=template&id=22b8d906&scoped=true"
import script from "./CostReportDetails.vue?vue&type=script&lang=js"
export * from "./CostReportDetails.vue?vue&type=script&lang=js"

import "./CostReportDetails.vue?vue&type=style&index=0&id=22b8d906&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22b8d906"]])

export default __exports__